import { css } from 'lit';

import color from '../../utils/get-color-token';
import toRem from '../../utils/to-rem';
import { disabled, m, on, p, transition } from '../../styles';

export function styles() {
	return css`
		:host {
			--m-close-button-color: ${color('color-text-primary')};
			--m-close-button-outline-color: ${color('color-primary-100')};
			--m-close-button-outline-offset: 2px;
		}

		.close-button {
			--button-color: transparent;
			--icon-color: var(--m-close-button-color);

			width: var(--button-size);
			height: var(--button-size);
			${m(0)};
			${p(0)};
			background-color: var(--button-color);
			border: none;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			${transition([{ property: 'background-color' }])};
		}

		.close-button.-size-small {
			--button-size: ${toRem('12px')};
			--icon-size: ${toRem('8px')};
		}

		.close-button.-size-default {
			--button-size: ${toRem('16px')};
			--icon-size: ${toRem('12px')};
		}

		.close-button.-size-large {
			--button-size: ${toRem('20px')};
			--icon-size: ${toRem('16px')};
		}

		.close-button.-inverted {
			--button-color: transparent;
			--icon-color: ${color('color-text-inverted')};
		}

		m-icon {
			--m-icon-size: var(--icon-size);
			--m-icon-color: var(--icon-color);

			display: block;
		}

		${on.focus('.close-button')} {
			outline: 1px solid var(--m-close-button-outline-color);
			outline-offset: var(--m-close-button-outline-offset);
		}

		${on.hover('.close-button')} {
			--button-color: var(--m-close-button-color);
			--icon-color: ${color('color-text-inverted')};
		}

		${on.hover('.close-button.-inverted')} {
			--button-color: ${color('color-text-inverted')};
			--icon-color: var(--m-close-button-color);
		}

		${disabled('.close-button')} {
			--icon-color: ${color('color-text-disabled')};
			cursor: default;
		}

		${disabled('.close-button', '*')} {
			pointer-events: none;
		}
	`;
}
